import React from 'react'
import './Contact.css'
import { MdOutlineEmail } from 'react-icons/md'
import { FaTelegram, FaGooglePlay } from 'react-icons/fa'

const Contact = () => {
  return (
    <section id='contact'>
      <div className="section__wrapper contact__container">
        <div className="section__header center">
          <h2 className='primary__title'>Get In Touch</h2>
          <p className="text__muted description">
            Have a project idea, question, or just want to say hello? Reach out through any of these channels.
          </p>
        </div>

        <div className="contact__group">
          <div className="contact__options">
            <article className="contact__option">
              <MdOutlineEmail className='contact__icon' />
              <h3>Email</h3>
              <h5 className="text__muted">contact@notragnar.com</h5>
              <a href="mailto:contact@notragnar.com" target='_blank' rel='noreferrer' className='btn btn__primary'>Send Email</a>
            </article>

            <article className="contact__option">
              <FaTelegram className='contact__icon' />
              <h3>Telegram</h3>
              <h5 className="text__muted">@Not_Ragnar</h5>
              <a href="https://telegram.me/Not_Ragnar" target='_blank' rel='noreferrer' className='btn btn__primary'>Message Me</a>
            </article>

            <article className="contact__option">
              <FaGooglePlay className='contact__icon' />
              <h3>Play Store</h3>
              <h5 className="text__muted">Ragnar Servers</h5>
              <a href="https://play.google.com/store/apps/developer?id=Ragnar+Servers" target='_blank' rel='noreferrer' className='btn btn__primary'>View Apps</a>
            </article>
          </div>

          <form>
            <input type="text" name='name' placeholder='Your Full Name' required />
            <input type="email" name='email' placeholder='Your Email' required />
            <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
            <button type='submit' className='btn btn__primary'>Send Message</button>
          </form>
        </div>
      </div>
    </section>
  )
}

export default Contact
